import { useT } from "../../../../i18n/I18nProvider";
import { type StaffUser } from "../../../../lib/auth";
import { SettingsSubsection } from "../subsection";
import { PHONE_TABS } from "./tabs";

/**
 * Settings -> Phone.
 *
 * The phone stack used to be nine of the thirteen entries in the Integrations
 * menu, which made that menu read as "the phone, and four other things". It is
 * its own tab now: the Twilio connection, the numbers we show and answer on,
 * when we answer, what is said, what is transcribed, and what happens to the
 * recordings afterwards.
 *
 * Every panel underneath is unchanged - this is the same side menu it always
 * had, one level up. The old `/settings/integrations/<tab>` links still land on
 * the right panel; see the redirects in `../integrations`.
 */
export function PhoneSettings({ user }: { user: StaffUser }) {
  const t = useT();
  return (
    <SettingsSubsection
      base="/settings/phone"
      tabs={PHONE_TABS}
      user={user}
      navLabel={t("settings.tabs.phone")}
      i18nPrefix="settings.phoneNav"
    />
  );
}
